var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFloor = function SvgFloor(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,43 C48.9188909,43.0031324 47.8453606,42.8270691 46.8269612,42.4795235 L5.53399034,28.4914119 C2.26145181,27.6111138 0,24.7530098 0,21.4973561 C0,18.2417024 2.26145181,15.3835983 5.53399034,14.5033003 L46.8269612,0.5151887 C48.8815305,-0.171729567 51.1184695,-0.171729567 53.1730388,0.5151887 L94.46601,14.5033003 C97.7385479,15.3835983 100,18.2417024 100,21.4973561 C100,24.7530098 97.7385479,27.6111138 94.46601,28.4914119 L53.1730388,42.4795235 C52.1546394,42.8270691 51.0811091,43.0031324 50,43 L50,43 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5529421,45.0854971 L88.0329993,43.0196745 L75.8189736,46.9545747 L90.7931086,51.6961293 L50.0869326,64.7009743 L9.38075657,51.6961293 L24.2896924,46.9349001 L12.0539331,43 L5.53399034,45.0658226 C2.26145181,45.8978615 0,48.5992805 0,51.6764548 C0,54.7536292 2.26145181,57.4550481 5.53399034,58.2870871 L46.8269612,71.5083515 C48.8803505,72.1638828 51.1196495,72.1638828 53.1730388,71.5083515 L94.46601,58.2870871 C97.7385479,57.4550481 100,54.7536292 100,51.6764548 C100,48.5992805 97.7385479,45.8978615 94.46601,45.0658226 L94.5529421,45.0854971 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4877429,67.0854971 L87.9678,65.0196745 L75.7537736,68.9545747 L90.6409764,73.7158036 L50.0217331,86.7009742 L9.38075657,73.6961293 L24.2896924,68.9349001 L12.0539331,65 L5.53399034,67.0658226 C2.26145181,67.8978615 0,70.5992804 0,73.676455 C0,76.753629 2.26145181,79.4550479 5.53399034,80.2870869 L46.8269612,93.5083516 C48.8803505,94.1638828 51.1196495,94.1638828 53.1730388,93.5083516 L94.46601,80.2870869 C97.7385479,79.4550479 100,76.753629 100,73.676455 C100,70.5992804 97.7385479,67.8978615 94.46601,67.0658226 L94.4877429,67.0854971 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFloor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "floor.e22d8f642eee7269dfe89e7c1f87b1a8.svg";